module.exports = __webpack_public_path__ + "static/media/DigiFleet-logo - Kopi.5ab9c1e2.png";